module.exports = __webpack_public_path__ + "img/org-light.02370f33.svg";